var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-page-header',{staticStyle:{"border":"1px solid rgb(235, 237, 240)"},attrs:{"ghost":false,"title":"Evaluasi Pelaksanaan"}},[_c('common-training-header',{attrs:{"in-header":true,"withUser":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }